import { NewGoal } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { createGoal } from 'shared/services/backend-api';

export const useCreateGoalMutation = () =>
  useMutation({
    mutationFn: async (goal: NewGoal) => createGoal(goal),
  });
